export const phoneRegex: RegExp =
  /^((\+[1-9]{1,4}[ \-]?)|(\([0-9]{2,3}\)[ \-]?)|([0-9]{2,4})[ \-]?)*[0-9]{3,4}?[ \-]?[0-9]{3,4}?$/;

export const faxRegex: RegExp =
  /^(\+)?(((((\d+)|(\(\d+\))|(\(\d+\s(\d)\)))(\s|-|\d+))+)|((\d+)|(\(\d+\))$)+)+\d$/;
